import React, { Component } from 'react';
import PropTypes from "prop-types";
import DatePicker, {registerLocale}  from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import fr from 'date-fns/locale/fr';


class ClientInfoComponent extends Component {

    constructor(props) {
        super(props)
        this.state = {

        }
        registerLocale('fr', fr);
        this.handleChange = this.handleChange.bind(this);
       
    }

    componentDidMount() {
    }

    handleChange = (e) =>{
      this.props.handleChange(e);
    };

    handleDateNaisChange = date => {

      this.props.handleDateNaisChange(date);

    };

    handleDatePermisChange = date => {

      this.props.handleDatePermisChange(date);

    };



    render() {

        return (
            <React.Fragment>
              <div class="row mt-3 py-3">
                <div class="col-md-6">
                  <form id="c_form-h" >
                  <div class="form-group row">
                  <label for="dateNaissance" class="col-4 col-form-label">Quelle est votre date de naissance ?</label>
                  <div class="col-8">
                  <DatePicker className="form-control" dateFormat="dd/MM/yyyy" locale="fr" name="dateNaissance" placeholderText="date de naissance" selected={this.props.dateNaissance} onChange={this.handleDateNaisChange}/>
                    </div>
                  </div> 
                    <div class="form-group row"> <label for="nombreSinistres" class="col-4 col-form-label">De combien de sinistres êtiez vous responsable durant ces 3 dernières années ?</label>
                      <div class="col-8">
                        <select class="form-control" id="nombreSinistres" name = "nombreSinistres" value={this.props.nombreSinistres} onChange={this.handleChange}>
                            <option value= "">---Nombre sinistres---</option>
                            <option value= "0">0</option>
                            <option value= "1">1</option>
                            <option value= "2">2 et plus</option>
                        </select>
                        </div>
                    </div>

                  </form>
                </div>
                <div class="col-md-6">
                  <form id="c_form-h" >
                    <div class="form-group row"> <label for="villeClient" class="col-4 col-form-label">Vous circulez majoritairement à ?</label>
                      <div class="col-8">
                      <select class="form-control" id="villeClient" name = "villeClient" value={this.props.villeClient} onChange={this.handleChange}>
                            <option value= "">---Sélectionner la ville---</option>
                            <option value= "700">CASABLANCA</option>
                            <option value= "701">RABAT</option>
                            <option value="702" >MARRAKECH</option>
                            <option value= "703">TANGER</option>
                            <option value= "704">AGADIR</option>
                            <option value= "705">OUJDA</option>
                            <option value= "706">AUTRE</option>
                        </select>
                        </div>
                    </div>
                    <div class="form-group row"> <label for="datePermis" class="col-4 col-form-label">Quand est ce vous avez eu votre permis ?</label>
                      <div class="col-8">
                      <DatePicker className="form-control" dateFormat="dd/MM/yyyy" locale="fr" name="datePermis" id="datePermis" placeholderText="date d'obtention du permis" selected={this.props.datePermis} onChange={this.handleDatePermisChange}/>
                       </div>
                    </div>
                   
                  </form>
                </div>
              </div>
            
          </React.Fragment>

        );
    }

}

ClientInfoComponent.propTypes = {
  handleDateNaisChange: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleDatePermisChange: PropTypes.func.isRequired
};
export default ClientInfoComponent;